define("shared/components/shared/mavely/links/link", ["exports", "@ember/component", "@ember/object", "@glimmer/component", "moment", "@ember/template-factory"], function (_exports, _component, _object, _component2, _moment, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@glimmer/component",0,"moment",0,"@ember/component"eaimeta@70e063a35619d71f
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <Shared::Ui::Button
    @additional="block"
    @class="cLB--linkItem is--item"
    @promise={{task @selectLink @link.id}}
    @variant="unstyled"
    data-qa-id={{concat "qa--mavely_product_" @link.meta_title}}
    data-test-id="link-item"
  >
    <div class="cLB--linkItem__productWrapper">
      <img
        alt={{@link.meta_title}}
        class="cLB--linkItem__image"
        data-test-id="link-item-thumbnail-image"
        id="mediaCanvas"
        src={{@link.meta_image}}
      />
      <div class="cLB--linkItem__text">
        <span class="u--text--light u--text--sm">
          {{@link.brand}}
        </span>
        <div class="cLB--linkItem__linkText">
          <Shared::Ui::Button
            @onClick={{this.openExternalLink}}
            @variant="unstyled"
            class="cLB--linkItem__title u--text--base"
            data-test-id="link-item-url"
            id={{concat "e--linkTitle-" @link.meta_title}}
            {{show-on-hover "e--link-icon"}}
          >
            {{@link.meta_title}}
            {{svg-jar
              "link"
              class="o--icon--xs o--icon--hl u--hide e--link-icon"
              id=(concat "e--linkIcon-" @link.meta_title)
            }}
          </Shared::Ui::Button>
        </div>
        <div class="cLB--linkItem__description u--text--light u--text--xs">
          {{@link.meta_description}}
        </div>
      </div>
    </div>
    <p class="u--text--sm u--text--hair u--text--light cLB--linkItem__dateWrapper">
      {{this.linkCreatedDate}}
    </p>
  </Shared::Ui::Button>
  */
  {
    "id": "VWe4nD/i",
    "block": "[[[8,[39,0],[[16,\"data-qa-id\",[28,[37,1],[\"qa--mavely_product_\",[30,1,[\"meta_title\"]]],null]],[24,\"data-test-id\",\"link-item\"]],[[\"@additional\",\"@class\",\"@promise\",\"@variant\"],[\"block\",\"cLB--linkItem is--item\",[28,[37,2],[[30,2],[30,1,[\"id\"]]],null],\"unstyled\"]],[[\"default\"],[[[[1,\"\\n  \"],[10,0],[14,0,\"cLB--linkItem__productWrapper\"],[12],[1,\"\\n    \"],[10,\"img\"],[15,\"alt\",[30,1,[\"meta_title\"]]],[14,0,\"cLB--linkItem__image\"],[14,\"data-test-id\",\"link-item-thumbnail-image\"],[14,1,\"mediaCanvas\"],[15,\"src\",[30,1,[\"meta_image\"]]],[12],[13],[1,\"\\n    \"],[10,0],[14,0,\"cLB--linkItem__text\"],[12],[1,\"\\n      \"],[10,1],[14,0,\"u--text--light u--text--sm\"],[12],[1,\"\\n        \"],[1,[30,1,[\"brand\"]]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"cLB--linkItem__linkText\"],[12],[1,\"\\n        \"],[8,[39,0],[[24,0,\"cLB--linkItem__title u--text--base\"],[24,\"data-test-id\",\"link-item-url\"],[16,1,[28,[37,1],[\"e--linkTitle-\",[30,1,[\"meta_title\"]]],null]],[4,[38,3],[\"e--link-icon\"],null]],[[\"@onClick\",\"@variant\"],[[30,0,[\"openExternalLink\"]],\"unstyled\"]],[[\"default\"],[[[[1,\"\\n          \"],[1,[30,1,[\"meta_title\"]]],[1,\"\\n          \"],[1,[28,[35,4],[\"link\"],[[\"class\",\"id\"],[\"o--icon--xs o--icon--hl u--hide e--link-icon\",[28,[37,1],[\"e--linkIcon-\",[30,1,[\"meta_title\"]]],null]]]]],[1,\"\\n        \"]],[]]]]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"cLB--linkItem__description u--text--light u--text--xs\"],[12],[1,\"\\n        \"],[1,[30,1,[\"meta_description\"]]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,2],[14,0,\"u--text--sm u--text--hair u--text--light cLB--linkItem__dateWrapper\"],[12],[1,\"\\n    \"],[1,[30,0,[\"linkCreatedDate\"]]],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]]]]]],[\"@link\",\"@selectLink\"],false,[\"shared/ui/button\",\"concat\",\"task\",\"show-on-hover\",\"svg-jar\"]]",
    "moduleName": "shared/components/shared/mavely/links/link.hbs",
    "isStrictMode": false
  });
  let MavelyLinksLinkComponent = _exports.default = (_class = class MavelyLinksLinkComponent extends _component2.default {
    get linkCreatedDate() {
      const expiryDate = new Date(this.args.link.created_at);
      return (0, _moment.default)(expiryDate).format('MMMM D, YYYY');
    }
    openExternalLink(event) {
      event.stopPropagation();
      window.open(this.args.link.original_url, '_blank');
    }
  }, (_applyDecoratedDescriptor(_class.prototype, "openExternalLink", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "openExternalLink"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, MavelyLinksLinkComponent);
});